import { FileText } from 'lucide-react';
import { PrzyciskZWyborem } from '@/components/PrzyciskZWyborem';
import { useI18n } from '@/lib/i18n';

/**
 * PRZYCISK TXT Z MINI LISTĄ „z nagłówkami / bez nagłówków".
 *
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *  ⚠️⚠️ POWSTAŁ NA ZGŁOSZENIE (31.08.2026): „Nie ma też tej opcji na brak nagłówków — dodaj to
 *  po prostu pod przyciskiem TXT, żeby przy kliknięciu była mini lista: Z nagłówkami / Bez
 *  nagłówków. I dopiero wtedy uruchomi się pobieranie".
 *
 *  ⚠️ OPCJA BYŁA, TYLKO NIE TAM, GDZIE SIĘ JEJ SZUKA. Przełącznik siedział w Ustawieniach wyspy
 *  („Pozostałe ustawienia"), a przycisk TXT jedynie MÓWIŁ DYMKIEM, co zrobi. Człowiek pobierający
 *  plik teraz musiał więc wyjść na inną zakładkę, przełączyć ustawienie wyspy dla wszystkich
 *  raportów, wrócić i pobrać — po to, żeby jeden plik wyszedł bez nagłówka.
 *
 *  ⚠️ USTAWIENIE WYSPY ZOSTAJE, ale dla HARMONOGRAMÓW: wysyłka o 6:00 nie ma komu zadać pytania.
 *  Tu pytamy, bo jest kto odpowiedzieć — i pobranie startuje po odpowiedzi, nie przed.
 *
 *  ⚠️ SAMA LISTA MIESZKA W `PrzyciskZWyborem` — tam siedzi obsługa klikania poza listą, Escape'u
 *  i fokusu, wspólna z przyciskiem mapy planogramu. Tutaj zostaje wyłącznie to, co jest o TXT.
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 */
export function PrzyciskTxt({
  onWybor,
  disabled = false,
  pracuje = false,
  wGore = false,
  size = 'sm',
  tytul,
}: {
  /** Wywoływane PO wyborze — dopiero to zaczyna pobieranie. */
  onWybor: (naglowki: boolean) => void;
  disabled?: boolean;
  /** Trwa pobieranie tego formatu — kręciołek zamiast ikony. */
  pracuje?: boolean;
  /** Lista rozwija się DO GÓRY — potrzebne w `sticky` stopce modala. */
  wGore?: boolean;
  size?: 'sm' | 'default';
  /** Dymek na przycisku; bez niego wchodzi opis z tłumaczeń. */
  tytul?: string;
}) {
  const { t } = useI18n();

  return (
    <PrzyciskZWyborem
      etykieta="TXT"
      ikona={FileText}
      dataExport="txt"
      ariaLabel={t('table.txtWybierz')}
      tytul={tytul ?? t('table.txtWybierz')}
      disabled={disabled}
      pracuje={pracuje}
      wGore={wGore}
      size={size}
      pozycje={[
        { klucz: 'z', etykieta: t('table.txtZNaglowkami'), opis: t('table.txtZNaglowkamiOpis') },
        { klucz: 'bez', etykieta: t('table.txtBezNaglowkow'), opis: t('table.txtBezNaglowkowOpis') },
      ]}
      onWybor={(klucz) => onWybor(klucz === 'z')}
    />
  );
}
